export type ScaleTypes = typeof scale;
export const scale = {
	space3xs: '0.4rem',
	space2xs: '0.8rem',
	spacexs: '1.2rem',
	spaceSm: '1.6rem',
	spaceMd: '2rem',
	spaceLg: '2.4rem',
	spaceXl: '3.2rem',
	space2xl: '4rem',
	space3xl: '4.8rem',
	space4xl: '6rem',
	space5xl: '8rem',
	space6xl: '10rem',
};
